import RateCap from "../utils/RateCap.js";
import global from "../global.js";
import VideoJs from "video.js";
// scss is managed at /opt/mcs_apps/apps/mtac/swc/f_mtac/src/app/styles/layouts/base/_floaters.scss

const log = global.log.getLogger("f_mtac.ui.Floaters");
log.setLevel(log.levels.WARN);

let Floaters = function () {
    //type = type;
    //element = element;
    this.floater_prefix = "floater_";
};

/**
 * @brief Save the current floaters in indexedDB: f_mtac.master.context/i/j.data.floaters
 * @param {*} context, context of the SITAC
 */
Floaters.prototype.save_context = async function (context) {
    log.debug("Floaters.save_context IN", context);

    let floaters = [];
    // find all floaters
    document.getElementById("floater_area").childNodes.forEach((child) => {
        // find floater prefix
        if (!child.id.startsWith(this.floater_prefix)) {
            // IS THIS CASE EVEN POSSIBLE?
            log.error("Floaters.save_context floater prefix not found");
            return; // returns the callback but continue the loop
        }

        // get the media type (audio, video, ...)
        const media_element = child.querySelector("[data-media_type]");
        if (media_element === null) {
            // IS THIS CASE EVEN POSSIBLE?
            log.error("Floaters.save_context data-media_type not found");
            return;
        }

        // Save essential data for each floater: type, element id, position and size
        floaters.push({
            element_id: child.id.substring(this.floater_prefix.length),
            media_type: $(media_element).data("media_type"), // e.g. ""audio"" --> remove the double cotes inside
            style: {
                width: child.style.width,
                height: child.style.height,
                top: child.style.top,
                left: child.style.left,
                visibility: child.style.visibility,
                z_index: child.style.z_index
            }
        });
    });
    log.debug("floaters = ", {floaters});
    context.data.floaters = floaters;
    await context.data_commit();
};

/**
 * @brief Restore the floaters according to what is in indexedDB: f_mtac.master.context/i/j.data.floaters
 * @param {*} context, context of the SITAC
 */
Floaters.prototype.restore_context = async function (context) {
    log.debug("Floaters.restore_context IN", context);
    if (!context) return;

    // remove proxy prototypes and other stuff from data
    let data = JSON.parse(JSON.stringify(context.data));
    if (data.floaters === undefined) {
        return;
    }
    log.debug("Floaters.restore_context", {data});

    data.floaters.forEach(async (element) => {
        // find element_id (the handle) and get the class "node"
        let container = document.getElementById(element.element_id);
        await this.create(element.media_type, container.children[0]);

        // set size and position
        const floater_id = this.floater_prefix + element.element_id;
        let floater = document.getElementById(floater_id);
        log.debug("Floaters.restore_context", {floater});
        if (floater != null) {
            floater.style.width = element.style.width;
            floater.style.height = element.style.height;
            floater.style.top = element.style.top;
            floater.style.left = element.style.left;
            floater.style.visibility = element.style.visibility;
            floater.style.z_index = element.style.z_index;
        }
    });
};

/**
 * @brief Remove all floaters. Remove innerHTML of "floater_area"
 */
Floaters.prototype.remove_all = function () {
    log.debug("Floaters.remove_all in");
    document.getElementById("floater_area").innerHTML = "";
};

/**
 * @brief Create a floating div that contains a media player (video, audio, image), we instantiate all the HTML
 * Multiple instances of Floater can manipulate a single Floater HTML node because we fetch from the DOM all variables.
 * @param string type of media (audio, video, image or stream)
 * @param element HTML element of the attachment used to create a Floater
 */
Floaters.prototype.create = async function (type, element) {
    let element_url;
    let media;

    log.debug("Floaters.create in", {type, element});

    // Element is the attachement used to create a Floater.
    //let element = element; // We use a local element because in the loadedmetadata, we can't access Floater property (this).
    let element_id = $(element).parent().attr("id"); // Using cash-dom we fetch element parent and get it's id.
    let element_position = $(element).position();
    let floater_area = $("#floater_area"); // Area containing all floaters
    let floater_container = document.getElementById(this.floater_prefix + element_id);

    // If the floater isn't created we start the creation otherwise we reset position.
    if (!floater_container) {
        log.debug("Floaters.create not existing");
        // We differentiate between Stream that will use a HTTP link and other medias that use local storage
        if (type == "stream") {
            element_url = $(element).children(".stream").attr("data-stream_url");
        }
        if (type == "image" || type == "video" || type == "audio") {
            media = await global.storage.selected_space.media_retrieve({
                local_id: $(element).data("media")
            });
            if (media === undefined) {
                return;
            }
            element_url = window.URL.createObjectURL(media.media_data);
        }

        if (!element_url) return;

        // We create a new id for some elements to fetch them more easily with getElementById
        // class active/inactive is used to managed to make disappear controls
        floater_area.append(`<div id='floater_${element_id}' class='floater_container active'></div>`);
        // active_object points to the cash-dom element, whereas floater_container points to the HTML element. (TODO: Must be uniformized)
        floater_container = document.getElementById(this.floater_prefix + element_id);
        let active_object = floater_area.find("#floater_" + element_id);

        // Add a control layer with the title and a close button and a fullscreen button 
        // add fullscreeen button if fullscreen=true
        const append_control_layer = (fullscreen) => {

            active_object.append(`<div id='control_layer_${element_id}'; class="control_layer"'></div>`);

            let control_layer = document.getElementById("control_layer_" + element_id);
            let title = "";
    
            // We fetch the user_name or name and if not we use internationalized placeholder
            if (!($(element).find(".user_name text").length == 0)) {
                title += $(element).find(".user_name text")[0].innerHTML;
            }
            if (!($(element).find(".name text").length == 0)) {
                if (title != "") title += " / ";
                title += $(element).find(".name text")[0].innerHTML;
            }
            if (title == "") {
                if (type == "stream") {
                    title = global.internationalization.text("resource.Floater-stream-textholder");
                } else if (type == "image") {
                    title = global.internationalization.text("resource.Floater-image-textholder");
                } else if (type == "video") {
                    title = global.internationalization.text("resource.Floater-video-textholder");
                } else if (type == "audio") {
                    title = global.internationalization.text("resource.Floater-audio-textholder");
                }
            }
            active_object.append("<text class='floater_title'>" + title + "</text>");
    
            // Button will be stacked vertically on the right
            $(control_layer).append("<button class='btn' style='top:calc(0.2*var(--wb))'><i class='f_mtac-icon-cross' aria-hidden='true' style='line-height: 1; vertical-align: middle' /></button>");
    
            let delete_action = false;
            let cancel_timer;
    
            // close button
            $(control_layer).find("button")[0].onclick = () => {
                log.debug("Floaters.button onclick", active_object);
                if (active_object[0] !== undefined && active_object[0].videojs !== undefined) {
                    active_object[0].videojs.dispose();
                }
                active_object.remove();
            };
    
            $(control_layer).find("button")[0].ontouchstart = () => {
                log.debug("Floaters.button ontouchstart");
    
                delete_action = true;
                cancel_timer = setTimeout(function () {
                    delete_action = false;
                }, 500);
            };
            $(control_layer).find("button")[0].ontouchend = () => {
                log.debug("Floaters.button ontouchend");
                if (delete_action) active_object.remove();
            };
            log.debug("", {cancel_timer});

            if (fullscreen == true) {
                $(control_layer).append("<button id='fullscreen' class='btn tool' style='top:calc(1.4*var(--wb));'><i class='f_mtac-icon-full-screen f_mtac-icon-xlg' aria-hidden='true'/></button>");
                // Image fullscreen use the GalleryViewer implementation
                $(control_layer).find("#fullscreen")[0].onclick = () => {
                    log.debug("Floaters.player image fullscreen onclick");
                    var image = $("#gallery_viewer img");
                    image.attr("src", element_url);
                    $("#gallery_viewer").css("display", null);
                    image.css("display", null);
                };
            }

        };

        let initialX = 0;
        let initialY = 0;
        let moveElement = false;

        let floater_player;
        let ratio_floater_player;

        // Better than onChange (use too much resources) and will keep the ratio of the media when redimensionning
        const myObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                log.debug("Floaters.button myObserver", entry.contentRect);
                active_object.css("height", entry.contentRect.width / ratio_floater_player + "px");
            });
        });

        // Variables used to display dynamically player controls
        let activity_timer;
        let activity_user = true;

        const on_mouse_move = () => {
            //log.debug( "Floaters.player floater_player mousemove", active_object);
            //e.preventDefault();
            if (!activity_user) {
                active_object.removeClass("inactive");
                active_object.addClass("active");
                if (floater_player.data("media_type") == "video") {
                    floater_player.attr("controls", "controls");
                }
                if (floater_player.data("media_type") == "stream") {
                    floater_player.attr("controls", "controls");
                }
                activity_user = true;
            }
            if (activity_timer) {
                clearTimeout(activity_timer);
                activity_timer = null;
            }
            activity_timer = setTimeout(function () {
                log.debug("Floaters.player mousemove timeout", active_object);
                activity_user = false;
                active_object.removeClass("active");
                active_object.addClass("inactive");
                if (floater_player.data("media_type") == "video") {
                    floater_player.removeAttr("controls");
                }
                if (floater_player.data("media_type") == "stream") {
                    floater_player.removeAttr("controls");
                }
            }, 4000);
            
        };

        const on_mouse_down = (e) => {
            log.debug("Floaters.player mousedown");
            e.preventDefault();
            resetZindex();
            floater_container.style.zIndex = 199;
            initialX = e.clientX;
            initialY = e.clientY;

            moveElement = true;
        };

        const on_touch_start = (e) => {
            log.debug("Floaters.player touchstart");
            e.preventDefault();
            resetZindex();
            if (!activity_user) {
                active_object.removeClass("inactive");
                active_object.addClass("active");
                if (floater_player.data("media_type") == "video") {
                    floater_player.attr("controls", "controls");
                }
                activity_user = true;
            }
            // On touch device, we need to touch a first time to show controls.
            if (activity_timer) {
                clearTimeout(activity_timer);
                activity_timer = null;
            }
            activity_timer = setTimeout(function () {
                log.debug("Floaters.player touchstart timeout");
                active_object.removeClass("active");
                active_object.addClass("inactive");
                activity_user = false;
            }, 4000);
            floater_container.style.zIndex = 199;
            initialX = e.touches[0].clientX;
            initialY = e.touches[0].clientY;

            moveElement = true;
        };


        // For each type of media, there is a specific way of creating it
        log.debug(`type = ${type}`);
        if (type == "stream") {

            append_control_layer(false); // without fullscreen button
            // hide close button until container is positioned
            active_object.removeClass("active");
            active_object.addClass("inactive");
            activity_user = false;

            // Use VideoJs because Chrome desktop doesnot support HLS (HTTP Live Streaming)
            const videoJsOptions = {
                autoplay: true,
                controls: true,
                liveui: true,
                sources: [{
                  src: element_url,
                  type: "application/x-mpegURL"
                }]
            };
            // Stream type need to be finished
            let video_id = "video_" + element_id;
            //active_object.append(`<video-js controls id=${video_id} class='vjs-control-bar' width='auto' height='auto' ></video-js>`);
            active_object.append(`<video id=${video_id} class="video-js vjs-fluid vjs-default-skin" controls preload="auto" style="width:inherit; padding:0;"></video>`);
    
            var player = VideoJs(video_id, videoJsOptions);
            player.play();
            floater_player = active_object.find("video");
            floater_player.data("media_type", "stream");

            log.debug("player =", player);
            player.ready = () => {
                log.debug("############### player is ready");
                
                // videojs prop will be used for dispose
                active_object.prop("videojs", player);
                
                player.on("mousedown", on_mouse_down);
                player.on("mousemove", on_mouse_move);
                player.on("touchstart", on_touch_start);
                player.on("loadedmetadata", function () {
                    log.debug("Floaters.player stream loadedmetadata");
                    let w = player.videoWidth();
                    log.debug(`width = ${w}`);
                    if (w != 0 && floater_container.style.width == "") {
                        let h = player.videoHeight();
    
                        //log.debug(`width = ${this.videoWidth()}, height = ${this.videoHeight()}`);
                        log.debug(`width = ${w}, height = ${h}`);
        
                        ratio_floater_player = w / h;
                        log.debug(`ratio = ${ratio_floater_player}`);
        
                        // At the creation we check if the image is created fully inside the display
                        floater_container.style.width = "400px";
                        floater_container.style.height = 400 / ratio_floater_player + "px";
                        floater_container.style.top = Math.max(0, element_position.top - floater_container.clientHeight) + "px";
                        floater_container.style.left = Math.min($(window).width() - 400, 
                                    Math.max(0, element_position.left + $(element).height() / 2 - 200)) + "px";
                        active_object.css("visibility", "visible");
    
                        activity_timer = setTimeout(function () {
                            active_object.removeClass("active");
                            active_object.addClass("inactive");
                            activity_user = false;
                        }, 4000);
    
                        // show close button because it is positioned
                        active_object.removeClass("inactive");
                        active_object.addClass("active");
                        activity_user = true;
                    }                
                });
            };
            
            log.debug("before player.off");


            // You can handle player events here, for example:
            player.on("waiting", () => {
                log.debug("player is waiting", player);
            });
        
            player.on("dispose", () => {
                log.debug("player will dispose");
            });

            myObserver.observe(floater_player[0]);
        } else if (type == "image") {
            append_control_layer(true); // with fullscreen button

            active_object.append("<img class='floater_player'></img>");
            floater_player = active_object.find("img");
            floater_player.data("media_type", type);
            floater_player.attr("src", element_url);
            floater_player.attr("width", "100%");

            // The image doesn't have dimension until the image is loaded that is why we wait onload
            floater_player[0].onload = function () {
                log.debug("Floaters.player image onload");
                ratio_floater_player = floater_player[0].naturalWidth / floater_player[0].naturalHeight;
                if (floater_container.style.width == "") {
                    active_object.css("width", "400px");
                    active_object.css("height", 400 / ratio_floater_player + "px");
                    // At the creation we check if the image is created fully inside the display
                    floater_container.style.top = Math.max(0, element_position.top - floater_container.clientHeight) + "px";
                    floater_container.style.left = Math.min($(window).width() - floater_container.clientWidth, Math.max(0, element_position.left + $(element).height() / 2 - floater_container.clientWidth / 2)) + "px";
                    active_object.css("visibility", "visible");
                }
                // We hide controls after creation if element is not used
                activity_timer = setTimeout(function () {
                    active_object.removeClass("active");
                    active_object.addClass("inactive");
                    activity_user = false;
                }, 4000);
            };

            // We listen to mousemove inside the player and if there is no movement we hide the controls
            floater_player[0].addEventListener("mousemove", on_mouse_move);
            floater_player[0].addEventListener("mousedown", on_mouse_down);
            floater_player[0].addEventListener("touchstart", on_touch_start);
           
            // Images need ratio
            myObserver.observe(floater_player[0]);

        } else if (type == "video") {

            append_control_layer(false); // without fullscreen button

            active_object.append("<video controls class='floater_player'></video>");
            floater_player = active_object.find("video");
            floater_player.data("media_type", type);
            floater_player.attr("src", element_url);
            floater_player.attr("width", "100%");

            // The video doesn't have good dimension until the controls have been loaded
            floater_player[0].addEventListener("loadedmetadata", function () {
                log.debug("Floaters.player video loadedmetadata");
                ratio_floater_player = floater_player[0].videoWidth / floater_player[0].videoHeight;
                if (floater_container.style.width == "") {
                    // first creation, fill width, height, top and left
                    active_object.css("width", "400px");
                    active_object.css("height", 400 / ratio_floater_player + "px");
                    floater_container.style.top = Math.max(0, element_position.top - floater_container.clientHeight) + "px";
                    floater_container.style.left = Math.min($(window).width() - floater_container.clientWidth, Math.max(0, element_position.left + $(element).height() / 2 - floater_container.clientWidth / 2)) + "px";
                    active_object.css("visibility", "visible");
                }
                // We hide controls after creation if element is not used
                activity_timer = setTimeout(function () {
                    log.debug("Floaters.player video loadedmetadata timeout");
                    active_object.removeClass("active");
                    active_object.addClass("inactive");
                    floater_player.removeAttr("controls");
                    activity_user = false;
                }, 4000);
            });

            // We listen to mousemove inside the player and if there is no movement we hide the controls
            floater_player[0].addEventListener("mousemove", on_mouse_move);
            floater_player[0].addEventListener("mousedown", on_mouse_down);
            floater_player[0].addEventListener("touchstart", on_touch_start);

            myObserver.observe(floater_player[0]);
        } else if (type == "audio") {
            append_control_layer(false); // without fullscreen button

            // We use video player to play audio because audio player doesn't have dimension so can't have eventListener
            active_object.append("<video controls class='floater_player'></video>");
            floater_player = active_object.find("video");
            floater_player.data("media_type", type);
            floater_player[0].style.setProperty("width", "100%");
            floater_player[0].style.setProperty("height", "calc(2.6*var(--wb))");
            floater_player.attr("src", element_url);
            // The video doesn't have good dimension until the controls have been loaded
            floater_player[0].addEventListener("loadedmetadata", function () {
                log.debug("Floaters.player audio loadedmetadata timeout");
                if (floater_container.style.width == "") {
                    active_object.css("width", "400px");
                    active_object.css("height", "calc(2.6*var(--wb))");
                    floater_container.style.top = Math.max(0, element_position.top - floater_container.clientHeight) + "px";
                    floater_container.style.left = Math.min($(window).width() - floater_container.clientWidth, Math.max(0, element_position.left + $(element).height() / 2 - floater_container.clientWidth / 2)) + "px";
                    active_object.css("visibility", "visible");
                }
                // We hide controls after creation if element is not used
                activity_timer = setTimeout(function () {
                    log.debug("Floaters.player audio loadedmetadata timeout");
                    active_object.removeClass("active");
                    active_object.addClass("inactive");
                    activity_user = false;
                }, 4000);
            });

            // We listen to mousemove inside the player and if there is no movement we hide the controls
            floater_player[0].addEventListener("mousemove", on_mouse_move);
            floater_player[0].addEventListener("mousedown", on_mouse_down);
            floater_player[0].addEventListener("touchstart", on_touch_start);
        }

        // At creation the floater have priority on already created floaters, and when we click on a floater we give him priority on everyone else
        let resetZindex = () => {
            log.debug("Floaters.player resetZindex");
            let floater_containers = floater_area.children();
            for (let i = 0; i < floater_containers.length; i++) {
                $(floater_containers[i]).css("z-index", 197);
            }
        };


        // Really important to preventDefault here, so when interacting with the player outside the controls we don't send event like play or pause.
        floater_player[0].addEventListener("click", (e) => {
            log.debug("Floaters.player click");
            e.preventDefault();
        });


        /**
         * @brief Constrain floater move so that:
         *      - for small images, half size keeps in the window
         *      - for big images, close and resize button can always be accessible
         * @param {*} newX new X position of the mouse
         * @param {*} newY new Y position of the mouse
         */
        let constrain_move = (newX, newY) => {
            // compute top and provide limits

            // if the image is not very tall
            if (floater_container.clientHeight / 2 < $(window).height()) {
                floater_container.style.top =
                    Math.min(
                        $(window).height() - floater_container.clientHeight / 2, // down limit (half of image is visible)
                        Math.max(
                            0 - floater_container.clientHeight / 2, // up limit (half of image is visible)
                            floater_container.offsetTop - (initialY - newY)
                        )
                    ) + "px"; // current position
            } else {
                // the image is very tall
                floater_container.style.top =
                    Math.min(
                        0, // down limit, 0 for the close button to be accessible
                        Math.max(
                            $(window).height() - floater_container.clientHeight - 10, // up limit, resize button shall be accessible, -10 provides some margin for resize
                            floater_container.offsetTop - (initialY - newY)
                        )
                    ) + "px"; // current position
            }

            // compute left and provide limits

            // if the image is not very large
            if (floater_container.clientWidth / 2 < $(window).width()) {
                floater_container.style.left =
                    Math.min(
                        $(window).width() - floater_container.clientWidth / 2, // right limit
                        Math.max(
                            0 - floater_container.clientWidth / 2, // left limit
                            floater_container.offsetLeft - (initialX - newX)
                        )
                    ) + "px";
            } else {
                // the image is very large
                floater_container.style.left =
                    Math.min(
                        $(window).width() - floater_container.clientWidth / 2, // right limit
                        Math.max(
                            $(window).width() - floater_container.clientWidth - 10, // left limit for the close and resize buttons to be accessible
                            floater_container.offsetLeft - (initialX - newX)
                        )
                    ) + "px";
            }
            //log.debug( `Floaters.player mousemove min1[${$(window).width() - floater_container.clientWidth / 2},max(${- floater_container.clientWidth / 2}, ${floater_container.offsetLeft - (initialX - newX)})]`);
            //log.debug( `Floaters.player mousemove top =${floater_container.style.left}`);
        };

        // While dragging the floater we check that never more that half the height and half the width are outside of the screen.
        // Add listener on "document" allows good behavior even when mouse leaves the floater area when moving
        document.addEventListener("mousemove", (e) => {
            if (moveElement) {
                //log.debug( "Floaters.player document mousemove");
                let rate_cap = new RateCap(() => {
                    e.preventDefault();
                    let newX = e.clientX;
                    let newY = e.clientY;

                    constrain_move(newX, newY);

                    initialX = newX;
                    initialY = newY;
                }, 60);
                // Better performance
                rate_cap.poll();
            }
        });

        // While dragging the floater we check that never more that half the height and half the width are outside of the screen.
        // Add listener on "document" allows good behavior even when mouse leaves the floater area when moving
        document.addEventListener("touchmove", (e) => {
            if (moveElement) {
                let rate_cap = new RateCap(() => {
                    e.preventDefault();
                    let newX = e.touches[0].clientX;
                    let newY = e.touches[0].clientY;

                    constrain_move(newX, newY);

                    initialX = newX;
                    initialY = newY;
                }, 60);
                // Better performance
                rate_cap.poll();
            }
        });

        document.addEventListener("mouseup", () => {
            log.debug("Floaters.player mouseup");
            moveElement = false;
        });
        document.addEventListener("touchend", () => {
            log.debug("Floaters.player touchend");
            moveElement = false;
        });
    } else {
        // We center the floater inside the display and reset the activity.
        floater_container.style.top = Math.max(0, element_position.top - floater_container.clientHeight) + "px";
        floater_container.style.left = Math.min($(window).width() - floater_container.clientWidth, Math.max(0, element_position.left + $(element).height() / 2 - floater_container.clientWidth / 2)) + "px";
    }

    log.debug("Floaters.create out");
};
export default Floaters;
